export default {"src":"/_next/static/media/double_file.57b44e8b.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};